import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromItem from 'src/app/core/stores/item/item.selector';
import { QRMenu } from 'src/app/models/common/QR-Menu';
import { ItemGroupService } from 'src/app/services/master/item-group.service';

@Component({
    standalone: true,
    selector: 'app-qr-menu',
    templateUrl: './qr-menu.component.html',
    styleUrl: './qr-menu.component.css'
})
export class QrMenuComponent {

  items: any[] = [];
  itemGroups: any[] = [];
  menuItems: QRMenu[] = [];
  groupedMenu: { [group: string]: QRMenu[] } = {};
  companyId: number = 0;
  financialYear: string = '';

  groupKeys: string[] = [];
  leftGroups: string[] = [];
  rightGroups: string[] = [];

  constructor(private route: ActivatedRoute, private store: Store, private itemGroupService: ItemGroupService) {}

  async ngOnInit(): Promise<void> {
    this.route.queryParamMap.subscribe((params) => {
      if (params.has('companyId')) {
        this.companyId = params.get('companyId') ? parseInt(params.get('companyId')) : 0;
      }

      if (params.has('financialYear')) {
        this.financialYear = params.get('financialYear');
      }
    });

    this.GetItemGroups();
  }

  GetAllItemsforCompany() {
    try {
      if (this.companyId > 0 && this.financialYear !== '') {
        this.items = [];
        this.store.select(fromItem.selectAllItems(this.companyId, this.financialYear)).subscribe((result) => {
          this.items = result;

          this.loadMenuItems();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  GetItemGroups() {
    try {
      this.itemGroups = [];
      this.itemGroupService.GetItemGroups().subscribe(
        (result) => {
          this.itemGroups = result;

          this.GetAllItemsforCompany();
        }, (err: Error) => {
          console.log(err.message);
        });
    }
    catch (err) {
      console.log(err);
    }
  }

  loadMenuItems() {
    if(this.itemGroups?.length > 0 && this.items?.length > 0) {
      this.menuItems = [];
      this.itemGroups.forEach((itemGroup) => {
        const groupeditems = this.items.filter((item) => item.underGroup == itemGroup.itemGroupId);

        if(groupeditems.length > 0) {
          groupeditems.forEach((item) => {
            this.menuItems.push({
              itemGroup: itemGroup.itemGroupName,
              itemName: item.itemName,
              salePrice: item.salesPrice
            });
          });
        }
      });

      this.groupedMenu = this.groupByItemGroup(this.menuItems);
      this.groupKeys = Object.keys(this.groupedMenu);
      const mid = Math.ceil(this.groupKeys.length / 2);
      this.leftGroups = this.groupKeys.slice(0, mid);
      this.rightGroups = this.groupKeys.slice(mid);
    }
  }

  groupByItemGroup(items: QRMenu[]): { [group: string]: QRMenu[] } {
    return items.reduce((acc, item) => {
      acc[item.itemGroup] = acc[item.itemGroup] || [];
      acc[item.itemGroup].push(item);
      return acc;
    }, {} as { [group: string]: QRMenu[] });
  }
}
